// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__2Ett1","amount":"Amount_amount__6lD07","tip":"Amount_tip__vFVTa","tipHeader":"Amount_tipHeader__JY-or","tipsWrap":"Amount_tipsWrap__8-IB_"};